<template>
  <div class="fl-sym-mt-10 fl-sym-p-2">
    <div class="fl-sym-text-xxs fl-sym-text-primary">CREATE PET PROFILE</div>
    <div class="fl-sym-text-5xl fl-sym-font-bold">What’s their Weight?</div>
    <div class="fl-sym-text-secondary fl-sym-text-lg fl-sym-mt-2">
      We need baseline information to triage your pet’s symptoms.
    </div>
    <div class="fl-sym-flex fl-sym-justify-between fl-sym-mt-5">
      <div
        class="fl-sym-w-1/5 fl-sym-h-1 fl-sym-bg-primary fl-sym-rounded-full"
      ></div>
      <div
        class="fl-sym-w-1/5 fl-sym-h-1 fl-sym-bg-primary fl-sym-rounded-full"
      ></div>
      <div
        class="fl-sym-w-1/5 fl-sym-h-1 fl-sym-bg-primary fl-sym-rounded-full"
      ></div>
      <div
        class="fl-sym-w-1/5 fl-sym-h-1 fl-sym-bg-graduate fl-sym-rounded-full"
      ></div>
    </div>
    <form class="fl-sym-mt-10">
      <div class="weight-widget">
        <WeightPicker v-model="weight" />
        <p
          class="fl-sym-text-secondary fl-sym-text-center fl-sym-text-lg fl-sym-mt-2 swipe-text"
        >
          Swipe bar or tap on number to update weight
        </p>
      </div>
      <button
        class="fl-sym-bg-primary fl-sym-mt-8 fl-sym-rounded-full fl-sym-text-white fl-sym-p-4 fl-sym-w-full fl-sym-text-sm symptom-btn"
        @click="handleStepThreeDispatch"
      >
        Complete profile
      </button>
    </form>
    <div class="fl-sym-text-center">
      <span
        class="fl-sym-mx-auto fl-sym-font-semibold fl-sym-text-primary fl-sym-text-sm  hover:fl-sym-text-opacity-75 fl-sym-cursor-pointer"
        @click="$router.go(-1)"
      >
        Back
      </span>
    </div>
  </div>
</template>

<script>
import WeightPicker from "@/components/form/slideWeight"
export default {
  components: {
    WeightPicker,
  },
  data() {
    return {
      weight: null,
    }
  },
  methods: {
    handleStepThreeDispatch(e) {
      e.preventDefault()
      this.$store.dispatch("pet/create_profile_step_3", this.weight)
    },
  },
}
</script>

<style>
.swipe-text {
  z-index: 100;
  position: relative;
  font-size: 13px;
  line-height: 18px;
}
</style>
